import React, { FC } from 'react';

export type MarkerIconProperties = { cluster?: boolean; count: number; total: number };

const MarkerIcon: FC<MarkerIconProperties> = ({ cluster = false, count, total }) => {
  const fac = (count / total) * 0.5;
  return (
    <div
      className={cluster ? 'dvinci-marker-cluster' : 'dvinci-marker-pin'}
      style={{
        width: `${20 + fac * 30}px`,
        height: `${20 + fac * 30}px`,
        paddingTop: `${-2 + (20 + fac * 30 - (2 * fac + 10)) / 2}px`,
        fontSize: `${2 * fac + 12}px`,
      }}
    >
      {count}
    </div>
  );
};

export default MarkerIcon;
